import { render, staticRenderFns } from "./TourDuLichList.vue?vue&type=template&id=1fb08b9b"
import script from "./TourDuLichList.vue?vue&type=script&lang=js"
export * from "./TourDuLichList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports